// @ts-nocheck
/* eslint-disable */
export const areaChartIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3333 5.00016L8 2.3335L4.66667 7.00016L2 5.00016V13.6668H14V5.00016H11.3333ZM12.6667 11.6335L8 8.00016L5.33333 11.6668L3.33333 10.0668V7.66683L4.96 8.88683L8.26667 4.2535L10.8667 6.3335H12.6667V11.6335Z" fill="currentColor"/></svg>`,
    name: 'area-chart' as const
};